export default "__VITE_ASSET__6ec2ba49__"